



























/* General */
import Vue from 'vue'

/* Mixins */

/* Components */
import TicketPortalHeader from './components/ticket-portal-header.vue'
import TicketPortalFooter from './components/ticket-portal-footer.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */
import { ITicketPortalOutputListing } from '@/api/types/response.types'

/* API */
import TicketPortalAPI from '@/api/modules/ticket-portal.api'

export default Vue.extend({
  name: 'TicketPortalListing',

  metaInfo(): any {
    return {
      title: this.data.ticketPortalName,
    }
  },

  components: { TicketPortalHeader, TicketPortalFooter },

  data() {
    return {
      RouteAssistant,
      isLoading: true,
      data: {} as ITicketPortalOutputListing,
    }
  },

  async created() {
    this.isLoading = true
    await this.getTickets()
    this.isLoading = false
  },

  methods: {
    async getTickets() {
      try {
        this.data = await TicketPortalAPI.get_Listing(
          this.$route.params.mailboxId,
        )
      } catch (error) {
        this.$error.emit(error)
      }
    },
  },
})
